import { render, staticRenderFns } from "./DizajnerzyZycia.vue?vue&type=template&id=ad99287a&scoped=true&"
import script from "./DizajnerzyZycia.vue?vue&type=script&lang=js&"
export * from "./DizajnerzyZycia.vue?vue&type=script&lang=js&"
import style0 from "./DizajnerzyZycia.vue?vue&type=style&index=0&id=ad99287a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad99287a",
  null
  
)

export default component.exports